<div class="group-edit-page">
  @if (isLoading()) {
    <zag-loading-state [message]="'common.loading' | translate" />
  } @else if (error()) {
    <zag-error-state [message]="error()!" [backLink]="'/settings/groups'" [backText]="'common.back' | translate" />
  } @else {
    <ng-template zagPageActions>
      <button zagButton type="button" [disabled]="isSaving() || !hasPendingChanges()" (click)="saveAll()">
        {{ 'common.save' | translate }}
      </button>
    </ng-template>

    <zag-entity-detail-layout>
      <div slot="sidebar">
        <zag-profile-summary-card
          [avatarName]="groupName()"
          [avatarIcon]="groupIcon()"
          [subtitle]="groupSubtitle()"
          [quickActionsTitle]="'common.quickActions' | translate"
          [quickActions]="quickActions()"
          [dangerActions]="dangerActions()"
          [dangerZoneTitle]="'common.dangerZone' | translate"
          (quickActionClick)="onQuickAction($event)"
          (dangerActionClick)="onDangerAction($event)"
        />
      </div>

      <div slot="content">
        <form [formGroup]="form">
          <zag-accordion>
            <!-- Details Section -->
            <zag-accordion-item [title]="'settings.groups.sections.details' | translate" icon="info" [expanded]="true">
              <div class="group-edit-page__row">
                <zag-form-field
                  [label]="'settings.groups.groupName' | translate"
                  [error]="getFieldError('name') ?? ''"
                  [required]="true"
                  forId="groupName"
                >
                  <zag-input id="groupName" formControlName="name" [placeholder]="'settings.groups.groupNamePlaceholder' | translate" />
                </zag-form-field>
              </div>

              <zag-form-field
                [label]="'settings.groups.groupDescription' | translate"
                [error]="getFieldError('description') ?? ''"
                forId="description"
              >
                <textarea
                  id="description"
                  class="group-edit-page__textarea"
                  formControlName="description"
                  rows="3"
                  [placeholder]="'settings.groups.groupDescriptionPlaceholder' | translate"
                ></textarea>
              </zag-form-field>
            </zag-accordion-item>

            <!-- Members Section -->
            <zag-accordion-item
              [title]="'settings.groups.tabMembers' | translate"
              icon="group"
              [badge]="memberList.memberCount()"
              [expanded]="true"
            >
              <sc-group-member-list #memberList [groupId]="groupId()" [isNew]="isNew()" [isSaving]="isSaving()" />
            </zag-accordion-item>

            <!-- Roles Section -->
            <zag-accordion-item
              [title]="'settings.groups.tabRoles' | translate"
              icon="security"
              [badge]="roleCountBadge()"
              [expanded]="true"
            >
              <div class="group-edit-page__section">
                <!-- Add Role Dropdown -->
                <zag-dropdown
                  [options]="unassignedRoleOptions()"
                  [placeholder]="'settings.groups.addRole' | translate"
                  [value]="selectedRoleToAdd()"
                  [disabled]="unassignedRolesLoading() || unassignedRoleOptions().length === 0"
                  (selectionChange)="onRoleToAddSelected($event)"
                />
                @if (unassignedRoleOptions().length === 0 && !unassignedRolesLoading()) {
                  <p class="group-edit-page__no-items">
                    {{ 'settings.groups.noUnassignedRoles' | translate }}
                  </p>
                }

                <!-- Roles List -->
                <div class="group-edit-page__list">
                  @if (rolesLoading()) {
                    <div class="group-edit-page__loading">
                      <span zagIcon="sync" class="spinning"></span>
                      <p>{{ 'common.loading' | translate }}</p>
                    </div>
                  } @else {
                    @for (role of allRoles(); track role.id) {
                      <div class="group-edit-page__item" [class.group-edit-page__item--local]="isLocalRoleAddition(role)">
                        <span zagIcon="security" class="group-edit-page__icon"></span>
                        <div class="group-edit-page__item-info">
                          <span class="group-edit-page__item-name">{{ role.id }}</span>
                          @if (role.description) {
                            <span class="group-edit-page__item-description">{{ role.description }}</span>
                          }
                        </div>
                        @if (isLocalRoleAddition(role)) {
                          <span class="group-edit-page__badge">
                            {{ 'settings.groups.pendingBadge' | translate }}
                          </span>
                        }
                        <button
                          type="button"
                          class="group-edit-page__remove-btn"
                          [title]="'common.remove' | translate"
                          (click)="removeRole(role)"
                        >
                          <span zagIcon="close"></span>
                        </button>
                      </div>
                    } @empty {
                      <p class="group-edit-page__empty">
                        {{ 'settings.groups.noRoles' | translate }}
                      </p>
                    }
                  }
                </div>
              </div>
            </zag-accordion-item>
          </zag-accordion>
        </form>
      </div>
    </zag-entity-detail-layout>

    @if (!isNew() && canAccessAuditLog()) {
      <zag-audit-log-panel
        schema="rbac"
        table="groups"
        [recordId]="groupId()!"
        [open]="auditPanelOpen()"
        (openChange)="auditPanelOpen.set($event)"
      />
    }
  }
</div>
